// 售后列表
<template>
  <div class="top_container flex_column_start_center">
  <div class="sld_after_sales_list">   
      <div class="after_sales_title flex_row_between_center ">
         <div class="title_content">售后管理</div>
		 <view class="title_search flex_row_start_center">
			 <el-input v-model="searchStr" :placeholder="L['输入商品名称/服务单号']" 
				class="search_input" >
			 </el-input>
			 <div class="seach_btn flex_row_center_center" @click="doSearch">搜索订单</div>
		 </view>
      </div>
      <div class="after_sales_list">
        <div class="after_sales_list_title flex_row_start_center">
          <div class="title_goods_des">{{ L['售后商品信息'] }}</div>
          <div class="title_apply_type">{{ L['售后类型'] }}</div>       
          <div class="title_status">{{ L['状态'] }}</div>
          <div class="title_options">{{ L['操作'] }}</div>
        </div>
        <div class="after_sales_list_con">
          <div class="list_con_pre" v-for="(afterSalesItem, afterSalesIndex) in afterSalesList.data"
            :key="afterSalesIndex">
            <div class="list_con_pre_title flex_row_start_center">
              <p class="per_t_pannel"><span class="pre_t_sub">{{ L['申请时间：'] }}</span>{{ afterSalesItem.buyerApplyTime }}</p>
              <div class="per_t_stub"></div>
			  <p class="per_t_pannel sev_num"> <span class="pre_t_sub">{{ L['服务单号：'] }}</span>{{ afterSalesItem.afsSn }}</p>
              <div class="kefu_container flex_row_start_center" @click="toKefu(afterSalesItem)">
                <img  class="kefu_img" src="@/assets/order/kefu.png"/>
                <div class="kefu_text">咨询客服</div>
              </div>
            </div>
            <div class="list_con">
              <div class="list_pre flex_row_start_center">
                 <div class="afs_goods">
					 <div class="afsProduct flex_row_start_center" v-for="(afsPItem,afsPIndex) in afterSalesItem.orderAfterServiceProductVOList" :key='afsPIndex' >
						<img class="productImg" :src="afsPItem.productImage"/>
						<div class="name_feature_num">
							<div class="goodsName">
								<span class="p_tip" v-if='afsPItem.isGift||afsPItem.cartType==3'>{{afsPItem.isGift?'赠品':'搭配'}}</span>
								{{afsPItem.productShortTitle}} 
							</div>																				
							<div class="num">¥{{afsPItem.returnMoneyAmount.toFixed(2)}} x{{afsPItem.returnNum}}</div>
						
						</div>
					 </div>
				 </div>
				 <div class="afs_type flex_row_center_start">
					 <div class="afs_type_content">{{afterSalesItem.afsTypeValue}}</div>
				 </div>
				 <div class="afs_status flex_row_center_start">
					 <div class="afs_status_content" :class="{'nopass':afterSalesItem.state==603,'close_cancel':afterSalesItem.state==601||afterSalesItem.state==602}">{{getStatusTxt(afterSalesItem.afsType,afterSalesItem.state)}}</div>
				 </div>
				 <div class="afs_opt flex_column_start_center" :class="{'hasTwo':showAfsCancel(afterSalesItem.afsType,afterSalesItem.state)}">
					 <div class="opt opt_1 flex_row_center_center"  @click="goRefundDetail(afterSalesItem)"  v-if="showReturnGoods(afterSalesItem.afsType,afterSalesItem.state)">寄回商品</div>	
				 	 <div class="opt opt_1 flex_row_center_center"  @click="goRefundDetail(afterSalesItem)" v-else>查看详情</div>	
          
					 <div class="opt opt_2 flex_row_center_center" @click="onCancelTap(afterSalesItem)"  v-if="showAfsCancel(afterSalesItem.afsType,afterSalesItem.state)">取消售后</div>
				 </div>
            </div>
          </div>
        </div>
          <SldCommonEmpty v-show="!afterSalesList.data.length" totalWidth="900"></SldCommonEmpty>
        </div>
      </div>	
  </div>
  <div class="flex_row_end_center sld_pagination sld_page_bottom" v-if="aftersalesDetail.data &&
      aftersalesDetail.data.pagination &&
      aftersalesDetail.data.pagination.total
      ">
      <el-pagination @current-change="handleCurrentChange" v-model:currentPage="current" :page-size="pageSize"
        layout="prev, pager, next" :total="aftersalesDetail.data.pagination.total"
        :hide-on-single-page="true">
      </el-pagination>
    </div>
  </div>
   <el-dialog  custom-class="cDlg"   v-model="cancelDialogVisible"   title="" width="269px" center :show-close="false" :align-center="true">
         <div class="cDlgContent">
           确认取消售后吗?
  	   </div>
         <template #footer>
           <div class="dialog-footer">
             <el-button @click="cancelDialogVisible = false">取消</el-button>
             <el-button class="cofirm_btn" @click="doCancel">
               确认
             </el-button>
			 
           </div>
         </template>
       </el-dialog>
</template>
<script>
import { useStore } from 'vuex'
import { onMounted, reactive, ref, getCurrentInstance, watchEffect } from 'vue'
import { ElMessage, ElPagination ,ElInput} from 'element-plus'
import SldCommonEmpty from '../../../components/SldCommonEmpty'
import { useRouter } from 'vue-router'
import MemberTitle from '../../../components/MemberTitle'


export default {
  components: {
    ElPagination,
    ElInput,
    MemberTitle,
    SldCommonEmpty
  },
  setup() {
	const store = useStore()
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage()
    const router = useRouter()
    const searchStr=ref('')
   
    const afterSalesList = reactive({ data: [] }) //售后列表
    const pageSize = ref(10)
    const current = ref(1)
    const aftersalesDetail = reactive({ data: {} }) //售后列表详情数据

	const curCanelItem=reactive({data:{}})
	const cancelDialogVisible=ref(false)
  
    onMounted(() => {
      getAfterSalesDet()
    })
   
    
	


  const getStatusTxt=(afsType,state)=>{
     	/*暂时这样*/
		var tmpStepTxt=[]
		try{	
        var tmpIndex=0;
				if(afsType==3){ //仅退款单
					if(state!=603){
						tmpStepTxt=[
							"提交申请",
							"商城审核",
							"等待退款",
							"退款完成",
						 ]
						 let indexInfo={
						 	100:{index:1},						
						 	400:{index:2},
						 	500:{index:2},						 	
						 	600:{index:3},
						 }
						 tmpIndex=indexInfo[state].index;
						
						 
					}else{
						tmpStepTxt=[
							"提交申请",
							"商城审核",
							"审核不通过",						
						]
						tmpIndex=2				
					}
					
				}
				else if(afsType==1){ //退货退款
					if(state==603||state==601||state==602){
						tmpStepTxt=[
							"提交申请",
							"商城审核",
							"审核不通过",						
						]
				
						if(state==601){
							tmpStepTxt[2]='售后取消'
					
						}else if(state==602){
							tmpStepTxt[2]='商城收货'
							tmpStepTxt.push('售后关闭')
							
							
						}
						tmpIndex=tmpStepTxt.length-1;
						
					}else {
						tmpStepTxt=[
							"提交申请",
							"商城审核",
							"商城收货",
							"等待退款",
							"退款完成"
						]
						let indexInfo={
							101:{index:1},
							200:{index:1},
							300:{index:2},
							301:{index:2},
							302:{index:3},
							500:{index:3},
							600:{index:4},
						}					
						tmpIndex=indexInfo[state].index;						
					}
				}else if(afsType==2){//换货
					if(state==603||state==601||state==602){
						
						tmpStepTxt=[
							"提交申请",
							"商城审核",
							"审核不通过",						
						]
					
						if(state==601){
							tmpStepTxt[2]='售后取消'
						
						}else if(state==602){
							tmpStepTxt[2]='商城收货'
							tmpStepTxt.push('售后关闭')
												
						}
						tmpIndex=tmpStepTxt.length-1;
					}else{
						tmpStepTxt=[
							"提交申请",
							"商城审核",
							"商城收货",
							"商城发货",
							"换货完成"
						]
						let indexInfo={
							102:{index:1},						
							200:{index:1},	
							300:{index:2},
							301:{index:2},	
							302:{index:2},
							305:{index:3},
							600:{index:4},
						}						
						tmpIndex=indexInfo[state].index;
					
					}
				}
			}catch(e){}
			return tmpStepTxt[tmpIndex]
  }

  const showAfsCancel=(afsType,state)=>{
      if(afsType==1){ //退款退货
         if(state==101||state==200||state==300){
            return true
         }
      }
      else if(afsType==2){ //换货
        if(state==102||state==200||state==300){
            return true
         }
      }
      return false
  }

  const showReturnGoods=(afsType,state)=>{
    if(afsType==1){ //退款退货
         if(state==300){
            return true
         }
      }
      else if(afsType==2){ //换货
        if(state==200||state==300){
            return true
         }
      }
      return false
  }
	
	const doSearch=()=>{
		if(searchStr.value){
			
		}
	}
	
	const toKefu = item => {
		proxy.$gotokefu({})
    }
	
    //获取售后订单列表
    const getAfterSalesDet = () => {
      let params = {        
        current: current.value,
        pageSize: pageSize.value
      }
      proxy.$post('v3/business/front/after/sale/list', params,'json').then(res => {

        //just for test
        //res=getTestRefunList()


        if (res.state == 200) {
          let result = res.data
          aftersalesDetail.data = result
          afterSalesList.data = result.list
        } else {
          ElMessage.error(res.msg)
        }
      }).then(()=>{
		toPageTop()
	  })
    }
    const toPageTop=()=>{
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth' // 可选，平滑滚动
		});
	}
    //上一页
    const handlePrevCilickChange = () => {
      current.value--
      getAfterSalesDet()
    }
    //下一页
    const handleNextCilickChange = () => {
      current.value++
      getAfterSalesDet()
    }
    //选择页面
    const handleCurrentChange = () => {
      getAfterSalesDet()
    }
	
	
	const onCancelTap=(afterSalesItem)=>{
		curCanelItem.data=afterSalesItem;
		cancelDialogVisible.value=true;
	}
	const doCancel=()=>{
		cancelDialogVisible.value=false;
		let params = {
		  afsSn: curCanelItem.data.afsSn
		}
		proxy.$post('v3/business/front/after/sale/cancel', params,'json').then((res) => {		
			
		  //just for test
		  //res.state =200	
			
		  if (res.state == 200) {          
				/*取消后怎么办*/  
				curCanelItem.data.state=601
		  } else {
			ElMessage.error(res.msg)
		  }
		})
		
	}
    //查看售后详情
    const goRefundDetail = afterSalesItem => {
      router.push({
        path: '/member/order/refund/detail',
        query: {  
          afsSn: afterSalesItem.afsSn
        }
      })
    }
 
    //去商品详情页
    const goGoodsDetail = productId => {
      proxy.$goGoodsDetail(productId)
    }

    const getTestRefunList=()=>{
			return{
				"data": {
					"list": [
						{
              "buyerApplyTime":'2022-05-23 15:43:34',
							"afsSn": "10237144993845",
							"afsType": 1,//	售后服务端类型：1-退货退款单，2-换货单，3-仅退款单
							"afsTypeValue": "退货退款",	//退款方式值：1-退货退款，2-换货，3-仅退款
							"memberId": 0,
							"memberName": "",
							returnMoneyAmount:'4000'  ,//test me							
							"orderAfterServiceProductVOList": [
								{
									cartType:1, //类型：1-主商品、2-增值服务、3-加价购
									isGift:1,//
									"goodsId": 0,
									"productShortTitle": "灵耀X双屏Pro 的府邸标压酷睿 双4K触控屏 高性能创作笔记高性能创作笔记都灵耀X双屏Pro 的府邸标压酷睿 双4K触控屏 高性能创作笔记高性能创作笔记都",
									"productId": 10,
									"productImage": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/T7XrAGvk09uqu3sFsv5.jpg?bindId=68",
									"returnMoneyAmount": 100,
									"returnNum": 1,
									"specValues": "蓝色"
								},
								{
									cartType:1, //类型：1-主商品、2-增值服务、3-加价购
									isGift:1,//
									"goodsId": 0,
									"productShortTitle": "灵耀X双",
									"productId": 10,
									"productImage": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/T7XrAGvk09uqu3sFsv5.jpg?bindId=68",
									"returnMoneyAmount": 100,
									"returnNum": 1,
									"specValues": "蓝色"
								},
								{
									cartType:3, //类型：1-主商品、2-增值服务、3-加价购
									isGift:0,//
									"goodsId": 0,
									"productShortTitle": "灵耀X双屏Pro 标压酷睿 ",
									"productId": 10,
									"productImage": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/T7XrAGvk09uqu3sFsv5.jpg?bindId=68",
									"returnMoneyAmount": 100,
									"returnNum": 1,
									"specValues": "蓝色"
								},{
									cartType:1, //类型：1-主商品、2-增值服务、3-加价购
									isGift:1,//
									"goodsId": 0,
									"productShortTitle": "3",
									"productId": 10,
									"productImage": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/T7XrAGvk09uqu3sFsv5.jpg?bindId=68",
									"returnMoneyAmount": 100,
									"returnNum": 1,
									"specValues": "蓝色"
								}
							],
							"orderSn": "",
							"orderState": 0,
							"state": 200,    //	退货/退款状态：100-买家申请仅退款；101-买家申请退货退款；102-买家退货给商家；200-商家同意退款申请；201-商家同意退货退款申请；202-商家拒绝退款申请(退款关闭/拒收关闭)；203-商家确认收货；300-平台确认退款(已完成)。换货状态：100-买家申请；101-买家发货；200-卖家审核失败；201-卖家审核通过；202-卖家确认收货；203-卖家拒收；204-卖家发货；301-买家收货（已完成）
							"stateValue": "申请中",
							"storeId": 0,
							"storeName": ""
						},
						{
							"buyerApplyTime":'2024-05-23 15:43:34',
							"afsSn": "10237144993846",
							"afsType": 2,//	售后服务端类型：1-退货退款单，2-换货单，3-仅退款单
							"afsTypeValue": "换货",	//退款方式值：1-退货退款，2-换货，3-仅退款
							"memberId": 0,
							"memberName": "",
							returnMoneyAmount:'4000'  ,//test me
							"orderAfterServiceProductVOList": [
								{
									cartType:1, //类型：1-主商品、2-增值服务、3-加价购
									isGift:0,//
									"goodsId": 0,
									"productShortTitle": "灵耀X双屏Pro 标压酷睿 双4K触控屏 高性能创作笔记高性能创作笔记都",
									"productId": 10,
									"productImage": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/T7XrAGvk09uqu3sFsv5.jpg?bindId=68",
									"returnMoneyAmount": 100,
									"returnNum": 1,
									"specValues": "蓝色"
								},
								
							],
							"orderSn": "",
							"orderState": 0,
							"state": 603,    //	退货/退款状态：100-买家申请仅退款；101-买家申请退货退款；102-买家退货给商家；200-商家同意退款申请；201-商家同意退货退款申请；202-商家拒绝退款申请(退款关闭/拒收关闭)；203-商家确认收货；300-平台确认退款(已完成)。换货状态：100-买家申请；101-买家发货；200-卖家审核失败；201-卖家审核通过；202-卖家确认收货；203-卖家拒收；204-卖家发货；301-买家收货（已完成）
							"stateValue": "",
							"storeId": 0,
							"storeName": ""
						},
						{
              "buyerApplyTime":'2022-05-23 15:43:34',
							"afsSn": "10237144993847",
							"afsType": 3,//	售后服务端类型：1-退货退款单，2-换货单，3-仅退款单
							"afsTypeValue": "仅退款",	//退款方式值：1-退货退款，2-换货，3-仅退款
							"memberId": 0,
							"memberName": "",
							returnMoneyAmount:'4000'  ,//test me
							"orderAfterServiceProductVOList": [
								{
									cartType:1, //类型：1-主商品、2-增值服务、3-加价购
									isGift:0,//
									"goodsId": 0,
									"productShortTitle": "灵耀X双屏Pro 标压酷睿 双4K触控屏 高性能创作笔记高性能创作笔记都",
									"productId": 10,
									"productImage": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/T7XrAGvk09uqu3sFsv5.jpg?bindId=68",
									"returnMoneyAmount": 100,
									"returnNum": 1,
									"specValues": "蓝色"
								},
								
							],
							"orderSn": "",
							"orderState": 0,
							"state": 600,    //	退货/退款状态：100-买家申请仅退款；101-买家申请退货退款；102-买家退货给商家；200-商家同意退款申请；201-商家同意退货退款申请；202-商家拒绝退款申请(退款关闭/拒收关闭)；203-商家确认收货；300-平台确认退款(已完成)。换货状态：100-买家申请；101-买家发货；200-卖家审核失败；201-卖家审核通过；202-卖家确认收货；203-卖家拒收；204-卖家发货；301-买家收货（已完成）
							"stateValue": "",
							"storeId": 0,
							"storeName": ""
						}
					],
					"pagination": {
						"current": 1,
						"pageSize": 10,
						"total": 100
					}
				},
				"msg": "",
				"state": 200,
				"timestamp": 0
			}
		}
	

    return {
      L,
      searchStr,
	    doSearch,
      getStatusTxt,
      showAfsCancel,
      showReturnGoods,    
      toKefu,
      afterSalesList,      
      pageSize,
      current,
      aftersalesDetail,
      handlePrevCilickChange,
      handleNextCilickChange,
      handleCurrentChange,
      goRefundDetail,    
      goGoodsDetail,
	  onCancelTap,
	  doCancel,
	  cancelDialogVisible,
      
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../style/base.scss';
@import '../../../style/iconfont.css';
@import '../../../style/afterSalesList.scss';
.cDlgContent{
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: Microsoft YaHei ;
		font-weight: bold;
		font-size: 15px;
	}

</style>
<style lang="scss">
	.cDlg{
		.el-dialog__body {
			padding-top: 20px !important;
			padding-bottom: 30px !important;
		}
		.el-dialog__header{
			display: none;
		}
	}
</style>